/*

  # Iframe video ratios

  The `div[data-hook~="videoRatios"]` setting attributes are:

  - `data-video-keywords`, a space-delimited array of keywords to match against the URL of an iframe to identify a video embed
  - `data-video-ratio`, the class name to use for the video ratio

    <div data-hook="videoRatios" data-video-keywords="youtube vimeo wistia" data-video-ratio="pt-16:9">

  This module is intended to be used on rich text areas but is not limited to them.

*/

import { assignController, selectAll } from '../api/element-manipulation'

assignController('videoRatios', element => {
  selectAll(element, element.dataset.videoKeywords.split(' ').map(keyword => `iframe[src*="${keyword}"]`).join(',')).forEach ( iframe => {
  const wrapper = document.createElement('div')
  wrapper.classList.add('p-relative')
  wrapper.classList.add(element.dataset.videoRatio)
  iframe.classList.add('p-absolute')
  iframe.classList.add('left-0')
  iframe.classList.add('top-0')
  iframe.classList.add('w-1/1')
  iframe.classList.add('h-1/1')
  iframe.style.width = ''
  iframe.style.height = ''
  iframe.parentNode.insertBefore ( wrapper, iframe )
  iframe.parentNode.removeChild(iframe)
  wrapper.appendChild(iframe)
} )
})
